/*
 * @Description: file content
 * @Author:
 * @Date: 2024-04-11 20:07:49
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-08-12 19:41:51
 */
import { post } from '@/utils/request'

// 获取动态未读数量  readType 类型:0：系统类型，1:所有非系统类型（默认），-1:所有
export function getFeedNotReadCount<T>(data: { enterpriseId: number; archiveId?: number; readType?: number }) {
  return post<T>({
    url: '/assistant/feed/getFeedNotReadCount',
    data,
  })
}
